/**
 * Copyright © 2025-2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Separator } from "@farmlands/shadcn-ui";
import { FC, Fragment, type JSX } from "react";

import TestIds from "../../../../testIds";

import AccountMenuItem from "./AccountMenuItem";
import { useFeatureLinkItems } from "./useFeatureLinkItems";

export interface IFeatureLinksProps {
  enableAccountDetails?: boolean;
  enableQuotes?: boolean;
  enableSeed?: boolean;
  enableDeclarations?: boolean;
  enableActivities?: boolean;
  enableOrders?: boolean;
  enableCards?: boolean;
  enablePayments?: boolean;
  enableStatements?: boolean;
}

const FeatureLinks: FC<IFeatureLinksProps> = (props: IFeatureLinksProps): JSX.Element => {
  const items = useFeatureLinkItems(props);

  return (
    <div
      className="flex flex-col gap-1"
      data-testid={TestIds.feat.account.userAccount.featureLinks.component}
    >
      {items.map((item, index) => {
        const previousItem = items[index - 1];
        const showDivider = !!previousItem && previousItem.group !== item.group;

        return (
          <Fragment key={item.id}>
            {showDivider && <Separator decorative={false} className="my-2" />}
            <AccountMenuItem
              label={item.label}
              icon={item.icon}
              testId={item.testId}
              scrollYPosition={item.scrollYKey}
              onClick={item.onClick}
            >
              {item.children}
            </AccountMenuItem>
          </Fragment>
        );
      })}
    </div>
  );
};

export default FeatureLinks;
